import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage"; 

const firebaseConfig = {
  apiKey: "AIzaSyBqCcFcrfZChMQ5mGNLHbBANb7oiINgyJw",
  authDomain: "avukatarzugul-135d4.firebaseapp.com",
  projectId: "avukatarzugul-135d4",
  storageBucket: "avukatarzugul-135d4.firebasestorage.app",
  messagingSenderId: "955409560920",
  appId: "1:955409560920:web:1e2d94c7dedb9e30b1a12d",
  measurementId: "G-PNFBD741NC"
};

const app = initializeApp(firebaseConfig);
getAnalytics(app);

export const db = getFirestore(app);
export const auth = getAuth(app);
export const storage = getStorage(app); 